import { api } from './client';

export interface ProfitRow {
  orderId: number;
  orderDate: string | null;
  orderName: string;
  valueWithGst: number;
  valueWithoutGst: number;
  totalCosting: number;
  freightCost: number;
  returnFreightCost: number;
  otherCost: number;
  grossProfit: number;
  unmappedLines: number;
  remark: string | null;
}

export interface ProfitReport {
  rows: ProfitRow[];
  totals: { valueWithGst: number; valueWithoutGst: number; totalCosting: number; freight: number; returnFreight: number; other: number; grossProfit: number };
}

export async function getOnlineProfitability(filter: { from?: string; to?: string; search?: string; status?: 'processed' | 'pending' } = {}): Promise<ProfitReport> {
  const r = await api.get<ProfitReport>('/shopify/profitability', { params: filter });
  return r.data;
}

/** Path of the Excel export for the same filter as the report — every matching order, no cap. */
export function onlineProfitabilityExportPath(filter: { from?: string; to?: string; search?: string; status?: 'processed' | 'pending' } = {}): string {
  const search = new URLSearchParams(
    Object.fromEntries(Object.entries(filter).filter(([, v]) => v != null && v !== '')) as Record<string, string>,
  ).toString();
  return `/shopify/profitability/export.xlsx${search ? `?${search}` : ''}`;
}

export async function saveOnlineOrderCosts(
  orderId: number,
  dto: { freightCost: number; returnFreightCost: number; otherCost: number; remark?: string },
): Promise<{ ok: boolean }> {
  const r = await api.patch(`/shopify/profitability/${orderId}`, dto);
  return r.data;
}
